import React from "react";

export const CustomMarker = (props) => {
	const { cx, cy, stroke, markerType, markerSize = 8, isMini } = props;
	const size = isMini ? markerSize * 0.5 : markerSize;

	switch (markerType) {
		case "Circle":
			return <circle cx={cx} cy={cy} r={size / 2} fill={stroke} stroke="#fff" strokeWidth={0}  onMouseEnter={props.onMouseEnter} />;

		case "Square":
			return <rect x={cx - size / 2} y={cy - size / 2} width={size} height={size} fill={stroke} stroke="#fff" strokeWidth={0} onMouseEnter={props.onMouseEnter} />;

		case "Rectangle":
			return <rect x={cx - size / 2} y={cy - size / 4} width={size} height={size * 0.5} fill={stroke} stroke="#fff" strokeWidth={0} onMouseEnter={props.onMouseEnter} />;

		case "Triangle": {
			const triangleSize = size * 0.55;
			return (
				<polygon
					points={`${cx},${cy - triangleSize} ${cx - triangleSize},${cy + triangleSize} ${cx + triangleSize},${cy + triangleSize}`}
					fill={stroke}
					stroke="#fff"
					strokeWidth={0}
					onMouseEnter={props.onMouseEnter}
				/>
			);
		}

		case "Cross": {
			const half = size / 2;
			const short = isMini ? size * 0.4 : half;
			const x1 = cx - short;
			const y1 = cy - short;
			const x2 = cx + short;
			const y2 = cy + short;

			const markerStroke = typeof stroke === "string" && stroke.trim() !== "" ? stroke : "#000000";

			return (
				<g
					onMouseEnter={props.onMouseEnter}
				>
					<line x1={x1} y1={y1} x2={x2} y2={y2} stroke={markerStroke} strokeWidth={2} />
					<line x1={x1} y1={y2} x2={x2} y2={y1} stroke={markerStroke} strokeWidth={2} />
				</g>
			);
		}

		// case "Circle":
		// 	if (isMini) {
		// 		return <circle cx={cx} cy={cy} r={markerSize / 2} fill={stroke} stroke="#fff" strokeWidth={0} />;
		// 	}
		// 	return <circle cx={cx} cy={cy} r={markerSize / 2} fill={stroke} stroke="#fff" strokeWidth={0} />;

		// case "Square":
		// 	if (isMini) {
		// 		return <rect x={cx - markerSize / 2} y={cy - markerSize / 2} width={markerSize * 1} height={markerSize * 1} fill={stroke} stroke="#fff" strokeWidth={0} />;

		// 		return <rect x={cx - markerSize / 4} y={cy - markerSize / 4} width={markerSize * 0.5} height={markerSize * 0.5} fill={stroke} stroke="#fff" strokeWidth={0} />;
		// 	}
		// 	return <rect x={cx - markerSize / 2} y={cy - markerSize / 2} width={markerSize * 1} height={markerSize * 1} fill={stroke} stroke="#fff" strokeWidth={0} />;

		// case "Rectangle":
		// 	if (isMini) {
		// 		return <rect x={cx - markerSize / 2} y={cy - markerSize / 2} width={markerSize} height={markerSize * 0.5} fill={stroke} stroke="#fff" strokeWidth={0} />;

		// 		return <rect x={cx - markerSize / 4} y={cy - markerSize / 4} width={markerSize * 0.5} height={markerSize * 0.25} fill={stroke} stroke="#fff" strokeWidth={0} />;
		// 	}
		// 	return <rect x={cx - markerSize / 2} y={cy - markerSize / 2} width={markerSize} height={markerSize * 0.5} fill={stroke} stroke="#fff" strokeWidth={0} />;

		// case "Triangle":
		// 	// Using a larger multiplier for the markerSize
		// 	const triangleSize = isMini ? (markerSize / 2) * 1.1 : (markerSize / 2) * 1.1; // Increase the size by 50%
		// 	return (
		// 		<polygon
		// 			points={`${cx},${cy - triangleSize} ${cx - triangleSize},${cy + triangleSize} ${cx + triangleSize},${cy + triangleSize}`}
		// 			fill={stroke}
		// 			stroke="#fff"
		// 			strokeWidth={0}
		// 		/>
		// 	);

		// case "Cross":
		// 	try {
		// 		// Force convert all potential string values to numbers with fallbacks
		// 		const numCX = !isNaN(parseFloat(String(cx))) ? parseFloat(String(cx)) : 0;
		// 		const numCY = !isNaN(parseFloat(String(cy))) ? parseFloat(String(cy)) : 0;

		// 		// Use a default size of 4 if markerSize is invalid or not provided
		// 		const defaultSize = 4;
		// 		const numMarkerSize = !isNaN(parseFloat(String(markerSize))) ? parseFloat(String(markerSize)) : defaultSize;

		// 		// Calculate the line coordinates
		// 		const x1 = isMini ? numCX - numMarkerSize * 0.4 : numCX - numMarkerSize / 2;
		// 		const y1 = isMini ? numCY - numMarkerSize * 0.4 : numCY - numMarkerSize / 2;
		// 		const x2 = isMini ? numCX + numMarkerSize * 0.4 : numCX + numMarkerSize / 2;
		// 		const y2 = isMini ? numCY + numMarkerSize * 0.4 : numCY + numMarkerSize / 2;

		// 		// Make sure stroke is a valid color value
		// 		// Check if stroke is a string and not empty
		// 		const defaultStroke = "#000000";
		// 		const markerStroke = typeof stroke === "string" && stroke.trim() !== "" ? stroke : defaultStroke;

		// 		// Default stroke width
		// 		const strokeWidth = 2;

		// 		return (
		// 			<g>
		// 				<line x1={x1} y1={y1} x2={x2} y2={y2} stroke={markerStroke} strokeWidth={strokeWidth} />
		// 				<line x1={x1} y1={y2} x2={x2} y2={y1} stroke={markerStroke} strokeWidth={strokeWidth} />
		// 			</g>
		// 		);
		// 	} catch (error) {
		// 		// Fallback to a simple circle with default values if there are any errors
		// 		const defaultFallbackSize = 4;
		// 		const defaultFallbackColor = "red";

		// 		return <circle cx={0} cy={0} r={defaultFallbackSize} fill={defaultFallbackColor} />;
		// 	}
		case "Diamond":
			return (
				<polygon
					points={`${cx},${cy - markerSize} ${cx - markerSize},${cy} ${cx},${cy + markerSize} ${cx + markerSize},${cy}`}
					fill={stroke}
					stroke="#fff"
					strokeWidth={0}
				/>
			);

		case "Star":
			return (
				<polygon
					points={`${cx},${cy - markerSize} ${cx + markerSize * 0.6},${cy - markerSize * 0.2} ${cx + markerSize},${cy + markerSize * 0.6} ${cx},${
						cy + markerSize * 0.3
					} ${cx - markerSize},${cy + markerSize * 0.6} ${cx - markerSize * 0.6},${cy - markerSize * 0.2}`}
					fill={stroke}
					stroke="#fff"
					strokeWidth={0}
				/>
			);

		case "Hexagon":
			return (
				<polygon
					points={`${cx},${cy - markerSize} ${cx + markerSize},${cy - markerSize / 2} ${cx + markerSize},${cy + markerSize / 2} ${cx},${cy + markerSize} ${
						cx - markerSize
					},${cy + markerSize / 2} ${cx - markerSize},${cy - markerSize / 2}`}
					fill={stroke}
					stroke="#fff"
					strokeWidth={0}
				/>
			);

		case "Pentagon":
			return (
				<polygon
					points={`${cx},${cy - markerSize} ${cx + markerSize},${cy - markerSize / 3} ${cx + markerSize * 0.6},${cy + markerSize} ${cx - markerSize * 0.6},${
						cy + markerSize
					} ${cx - markerSize},${cy - markerSize / 3}`}
					fill={stroke}
					stroke="#fff"
					strokeWidth={0}
				/>
			);

		case "Plus":
			return (
				<>
					<line x1={cx} y1={cy - markerSize} x2={cx} y2={cy + markerSize} stroke={stroke} strokeWidth={0} />
					<line x1={cx - markerSize} y1={cy} x2={cx + markerSize} y2={cy} stroke={stroke} strokeWidth={0} />
				</>
			);

		case "HorizontalLine":
			return <line x1={cx - markerSize} y1={cy} x2={cx + markerSize} y2={cy} stroke={stroke} strokeWidth={0} />;

		case "VerticalLine":
			return <line x1={cx} y1={cy - markerSize} x2={cx} y2={cy + markerSize} stroke={stroke} strokeWidth={0} />;

		case "ArrowUp":
			return (
				<polygon
					points={`${cx},${cy - markerSize} ${cx - markerSize},${cy + markerSize} ${cx + markerSize},${cy + markerSize}`}
					fill={stroke}
					stroke="#fff"
					strokeWidth={0}
				/>
			);

		case "ArrowDown":
			return (
				<polygon
					points={`${cx - markerSize},${cy - markerSize} ${cx + markerSize},${cy - markerSize} ${cx},${cy + markerSize}`}
					fill={stroke}
					stroke="#fff"
					strokeWidth={0}
				/>
			);

		case "ArrowRight":
			return (
				<polygon
					points={`${cx - markerSize},${cy - markerSize} ${cx + markerSize},${cy} ${cx - markerSize},${cy + markerSize}`}
					fill={stroke}
					stroke="#fff"
					strokeWidth={0}
				/>
			);

		case "ArrowLeft":
			return (
				<polygon
					points={`${cx + markerSize},${cy - markerSize} ${cx - markerSize},${cy} ${cx + markerSize},${cy + markerSize}`}
					fill={stroke}
					stroke="#fff"
					strokeWidth={0}
				/>
			);

		case "Heart":
			return (
				<path
					d={`M${cx},${cy + markerSize / 2}
	          C${cx - markerSize},${cy - markerSize},${cx - markerSize * 1.5},${cy - markerSize / 2},${cx},${cy - markerSize}
	          C${cx + markerSize * 1.5},${cy - markerSize / 2},${cx + markerSize},${cy - markerSize},${cx},${cy + markerSize / 2}`}
					fill={stroke}
					stroke="#fff"
					strokeWidth={0}
				/>
			);

		case "Bolt":
			return (
				<polygon
					points={`${cx - markerSize / 2},${cy - markerSize} ${cx + markerSize / 2},${cy - markerSize} ${cx - markerSize / 4},${cy} ${cx + markerSize / 4},${cy} ${
						cx - markerSize
					},${cy + markerSize} ${cx + markerSize},${cy + markerSize / 2}`}
					fill={stroke}
					stroke="#fff"
					strokeWidth={0}
				/>
			);

		case "Cloud":
			return (
				<path
					d={`M${cx - markerSize},${cy}
	          C${cx - markerSize * 1.2},${cy - markerSize * 0.5},${cx - markerSize * 0.5},${cy - markerSize},${cx},${cy - markerSize}
	          C${cx + markerSize * 0.5},${cy - markerSize},${cx + markerSize * 1.2},${cy - markerSize * 0.5},${cx + markerSize},${cy}
	          C${cx + markerSize * 1.3},${cy + markerSize * 0.5},${cx + markerSize * 0.5},${cy + markerSize},${cx},${cy + markerSize}
	          C${cx - markerSize * 0.5},${cy + markerSize},${cx - markerSize * 1.3},${cy + markerSize * 0.5},${cx - markerSize},${cy}`}
					fill={stroke}
					stroke="#fff"
					strokeWidth={0}
				/>
			);
		default:
			// fallback to circle
			return <g>
				<circle cx={cx} cy={cy} r={size / 2} fill={stroke} />
  				{/* Invisible larger circle for mouse events */}
				<circle
					cx={cx}
					cy={cy}
					r={Math.max(size / 2, 6)} // Minimum 6px radius for interaction
					fill="transparent"
					style={{ pointerEvents: 'all', cursor: 'pointer' }}
					onMouseEnter={props?.onMouseEnter}
					onMouseMove={props?.onMouseMove}
					onMouseLeave={props?.onMouseLeave}
				/>
			</g>;
		// default:
		// 	return <circle cx={cx} cy={cy} r={markerSize} fill={stroke} stroke="#fff" strokeWidth={0} />;
	}
};

interface CustomMarkerProps {
	markerType?: "Circle" | "Square" | "Triangle" | "Cross";
	markerSize?: number;
	stroke?: string;
}

export const CustomMarkerTooltip: React.FC<CustomMarkerProps> = ({ markerType = "Circle", stroke = "#000" }) => {
	const markerSize = 8;
	switch (markerType) {
		case "Circle":
			return (
				<div
					style={{
						minWidth: markerSize,
						minHeight: markerSize,
						backgroundColor: stroke,
						borderRadius: "50%",
						marginRight: 8,
						display: "inline-block",
					}}
				/>
			);
		case "Square":
			return (
				<div
					style={{
						minWidth: markerSize,
						minHeight: markerSize,
						backgroundColor: stroke,
						marginRight: 8,
						display: "inline-block",
					}}
				/>
			);
		case "Triangle":
			return (
				<div
					style={{
						width: 0,
						height: 0,
						borderLeft: `${markerSize / 2}px solid transparent`,
						borderRight: `${markerSize / 2}px solid transparent`,
						borderBottom: `${markerSize}px solid ${stroke}`,
						marginRight: 8,
						display: "inline-block",
					}}
				/>
			);
		case "Cross":
			return (
				<div
					style={{
						position: "relative",
						minWidth: markerSize,
						minHeight: markerSize,
						marginRight: 8,
						display: "inline-block",
						transform: "rotate(45deg)",
					}}>
					<div
						style={{
							position: "absolute",
							top: 0,
							left: markerSize / 2 - 1,
							width: 2,
							height: markerSize,
							backgroundColor: stroke,
						}}
					/>
					<div
						style={{
							position: "absolute",
							left: 0,
							top: markerSize / 2 - 1,
							width: markerSize,
							height: 2,
							backgroundColor: stroke,
						}}
					/>
				</div>
			);
		default:
			return (
				<div
					style={{
						minWidth: markerSize,
						minHeight: markerSize,
						backgroundColor: stroke,
						borderRadius: "50%",
						marginRight: 8,
						display: "inline-block",
					}}
				/>
			);
	}
};
